import UPButton from 'components/button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Lang from 'types/Lang';
import {
  OnboardingActionsContainer,
  OnboardingImage,
  OnboardingOptionsContainer,
  OnboardingPresentationContainer,
  OnboardingText,
  OnboardingTitle,
} from './styles';

const OnboardingPresentation: React.FC<{ isFlowOpen: boolean; setIsFlowOpen: (value: boolean) => void }> = ({
  isFlowOpen,
  setIsFlowOpen,
}) => {
  const navigate = useNavigate();
  const [, i18n] = useTranslation();

  const handleStartFlow = () => {
    setIsFlowOpen(true);
    i18n.changeLanguage(Lang.nl);
  };

  return (
    <OnboardingPresentationContainer hidden={isFlowOpen}>
      <OnboardingImage />
      <OnboardingOptionsContainer>
        <OnboardingTitle variant="h2">Welkom bij UPay</OnboardingTitle>
        <OnboardingText variant="h5">
          Ben je klaar om de flexibiliteit en het gemak van tijdelijke tewerkstelling bij UP te ervaren? Klik op
          &apos;Let&apos;s get started&apos; hieronder om met je onboarding te starten.
        </OnboardingText>
        <OnboardingActionsContainer>
          <UPButton text="Let's get started" onClick={handleStartFlow} withArrow />
          <UPButton text="Go to login" onClick={() => navigate('/login')} outlined />
        </OnboardingActionsContainer>
      </OnboardingOptionsContainer>
    </OnboardingPresentationContainer>
  );
};

export default OnboardingPresentation;
